import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-addbankbranchpopup',
  templateUrl: './addbankbranchpopup.component.html',
  styleUrls: ['./addbankbranchpopup.component.css']
})
export class AddbankbranchpopupComponent implements OnInit {



  formname:String="BankBranch";
  //Display
  formmode:string="Add";
  
   //Mode Values
   isaddmode:boolean=false;
   iseditmode:boolean=false;
   isdeletemode:boolean=false;
   isviewmode:boolean=false;
  
  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  
   //Save Validation
   submitted:boolean;
   successfully:boolean;
   saveloading: boolean;
  
   //Edit Get Values
   bankColl:any=[];
   bankbranchColl:any=[];
   bankbranchBO:any={};
   bankbranchid:number=0
   
   bankbranchform=new FormGroup({
    bankid:new FormControl(null,Validators.required), 
    bankbranchid:new FormControl(0),          
    branchname:new FormControl('',Validators.required), 
    ifsccode:new FormControl('') ,
    inactive:new FormControl(false),  
   });
  
   @Output() emitData = new EventEmitter();

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private activeModal: NgbActiveModal,) {

    this.fnServiceChanges();
  }
    
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }
  
    });
  }
  
  
  
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
  
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  
  fnOnInitForm() {
      try{
          this.isaddmode=true;
          this.bankbranchform.reset();
          this.fnInitializeFormGroup(); 
  
        
          this.fngetBank();
      }catch(ex){
        this.fnShowErrorMsg(ex);
      }
  
  }
  
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.bankbranchid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
  
    return _check;
  }
  
  fnUserFailedForm() {
    this.isprivilage = true;
  }
  
  
  fnInitializeFormGroup(){
      this.bankbranchform.setValue({
        bankbranchid:0,
        bankid:null,    
        branchname:'',
        ifsccode:'',
        inactive:false              
      })
  }
  
  fngetBank() {
    if (this.showProgress) {
      return;
    }           
    var data = {
      'bankid':0,
      'companyid':this.loginService.fnGetCompanyId()          
    }
    this.appService.getBank(data)
    .subscribe(
      (res)=>{                
        if(res.json().status===200){  
       
  
          this.bankColl=res.json().result;
        
        }
        else {
       
  
          this.loginService.fnAPIError(res.json())
        }
        
    },
    (err)=>{ 
  
           
      this.toastr.error('Error', err);
    })
  }
  
  
  
  
  //Save Btn Click
  fnSaveBtnClick(){
      try{
          if (this.saveloading) {
        return;        
    }
    
        this.submitted=true;
        this.successfully=false;
        this.saveloading = true;
        //Validate
        if(this.bankbranchform.valid){
          
             //Check
            var data = {
                  'bankbranchid': this.bankbranchid, 
                  'bankid':this.bankbranchform.get('bankid').value,                     
                  'branchname':this.bankbranchform.get('branchname').value,
                  'ifsccode':this.bankbranchform.get('ifsccode').value, 
                  'inactive':this.bankbranchform.get('inactive').value,            
                  'companyid':this.loginService.fnGetCompanyId(),
                  'createdby': this.loginService.fnGetModUserId(),  
                 'modifiedby':this.loginService.fnGetModUserId(),                                                              
            }
  
          
            this.appService.fnCheckBankbranch(data).subscribe(
              (res)=>{
                if(res.json().status===200){  
                  var _checkresult=res.json().result[0].checkfield;
                
                  if(_checkresult==="done"){
                      
                    
                          //Insert 
                          this.fnInsertBankbranch(data);
                      
                  }
                  else {       
                  
                        if(_checkresult==="name"){
                          this.saveloading = false;
  
                          this.bankbranchform.controls['branchname'].setErrors({'notfound': true});
                        }
                  }
                }
                else {
                  this.saveloading = false;
  
                  this.loginService.fnAPIError(res.json())
                }
            },
            (err)=>{
              this.saveloading = false;
  
                this.toastr.error('Error', err);           
            });
         }
      }catch(ex){
        this.saveloading = false;
  
        this.fnShowErrorMsg(ex);
      }
  }
  
  //Insert
  fnInsertBankbranch(data){    
    
      this.appService.fnInsertBankbranch(data).subscribe(
        (res)=>{
          this.saveloading = false;
  
          if(res.json().status===200){  
            if(res.json().result!=""){
              this.toastr.success('', "The new Bankbranch has been added successfully.Insert Successfully");
              this.fnInsertActivityLog('INSERT', 0, data.branchname);
            
              var result = res.json().result;
            
              var bankbranchid = 0;
              if (result.length > 0) {
                bankbranchid = result[0].bankbranchid
              }
              this.emitData.emit(bankbranchid);
              this.activeModal.close(true);
    
  
            }  
            else {
              this.loginService.fnAPIError(res.json())
            }
          }
          (err) => {
            this.saveloading = false;        
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
  
    }
  
  

  
  fnInsertActivityLog(action,refno,desc){
    try{
      var data={
        logtype:action,
        logat:this.formname,
        refnum:refno,
        logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
        logby:this.loginService.fnGetModUserId(),
      }
    
      
  
      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{
       
        });
  
    }catch{
  
    }
   }
   public decline() {
     this.activeModal.close(false);
   }
 
 
   private fnShowErrorMsg(ex) {
     this.toastr.warning('Internal Error', ex);
   }
 
 
 }
 
 
 
 